import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
} from "antd";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import {
  DetailFields,
  DownArrowDraw,
  HaberForm,
  RightDrawerContainer,
} from "../../styledElements";
import { useForm } from "antd/lib/form/Form";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { useEffect, useState } from "react";
import {
  getAllGradesForConfig,
  getGradeQualitiesForConfig,
  getJobCardSerialNumberParam,
  updateOrderCreationConfig,
} from "../../../Services/settingsServices";

const ParameterFormItem = ({
  form,
  index,
  parameters,
  setParameters,
  parametersConfig,
  typeOptions,
  setTypeOptions,
  getGradeList,
  getQualityList,
  setDeletedParameter,
  setPlyOptions
}) => {
  const { Option } = Select;
  const onDeleteParameter = (index) => {
    if (parameters[index].type) {
      setTypeOptions((prev) => [...prev, parameters[index].type]);
    }
    if (parameters[index].type == "Type" && parameters[index].defaultValue == "Sheet") {
      setPlyOptions([1, 2, 3, 4]);
    }
    if (parameters[index].type && parameters[index].type == "Grade") {
      setTypeOptions((prev) => prev.filter((type) => type != "Quality"));
      setParameters(
        parameters.filter(
          (parameter, ind) => ind != index && parameter.type != "Quality"
        )
      );
    } else setParameters(parameters.filter((parameter, ind) => ind != index));
    setDeletedParameter(parameters[index]?.type);

  };
  const handleParameterTypeChange = (e) => {
    form.setFieldsValue({
      [`type${index + 1}`]: e,
    });
    if (e == "Grade") {
      getGradeList();
      setTypeOptions((prev) => [...prev, "Quality"]);
    }
    if (e == "Quality") {
      const gradeSelected = parameters.filter(parameter => parameter.type == "Grade")
      getQualityList(gradeSelected[0].defaultValue);
    }
    setTypeOptions((prev) => prev.filter((type) => type != e));
    parameters[index].type &&
      parameters[index].type != "Quality" &&
      setTypeOptions((prev) => [...prev, parameters[index].type]);
    if (parameters[index].type == "Grade") {
      setTypeOptions((prev) => prev.filter((type) => type != "Quality"));
      setParameters((prev) =>
        prev.filter((parameter) => parameter.type != "Quality")
      );
    }
    setParameters((prev) =>
      prev.map((parameter, ind) => {
        if (ind == index)
          return {
            ...parameter,
            defaultValue: (["Length Unit","Weight Unit"].includes(e))?"default_unit":"",
            type: e,
          };
        else return parameter;
      })
    );
  };

  const handleParameterVisibilityChange = (e) => {
    setParameters(
      parameters.map((parameter, ind) => {
        if (ind == index)
          return {
            ...parameter,
            visibility: e,
          };
        else return parameter;
      })
    );
  };

  const handleParameterValueChange = (e) => {
    form.setFieldsValue({
      [`defaultValue${index + 1}`]:
        parameters[index].type &&
          parametersConfig[parameters[index].type].type == "dropdown"
          ? e
          : e.target.value,
    });
    form.validateFields();
    setParameters(
      parameters.map((parameter, ind) => {
        if (ind == index)
          return {
            ...parameter,
            defaultValue:
              parameter.type &&
                parametersConfig[parameter.type].type == "dropdown"
                ? e
                : e.target.value,
          };
        else return parameter;
      })
    );
    if (parameters[index].type == "Type" && e == "Sheet") {
      setPlyOptions([1]);
      setParameters(prev => prev.map(parameter => {
        if (parameter.type == "Ply") {
          return {
            ...parameter,
            defaultValue: 1,
          }
        }
        else
          return parameter
      }))
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "15px",
        }}
        className="titleWithText"
      >
        <h5>{`Parameter ${index + 1}`}</h5>
        <Tooltip
          placement="bottomRight"
          title={"Delete Parameter"}
          className="edit-tooltip"
          getPopupContainer={(triggerNode) => triggerNode}
        >
          <Button
            className="textTypeBtn textBtnIcon"
            style={{ marginLeft: "0", display: "flex", gap: "5px" }}
            onClick={() => onDeleteParameter(index)}
          >
            <Iconmoon icon="delete" size={14} color="#EA655B" />
            Delete
          </Button>
        </Tooltip>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
        <Row style={{ columnGap: "12px" }}>
          <Col span={12}>
            <Form.Item
              name={`type${index + 1}`}
              style={{ marginBottom: "0px" }}
              rules={[
                {
                  required: true,
                  message: "This field is required",
                },
              ]}
            >
              <p style={{ padding: "4px" }}>Parameter Type</p>
              <Select
                placeholder="Select"
                suffixIcon={<DownArrowDraw />}
                onChange={handleParameterTypeChange}
                value={parameters[index].type || null}
                getPopupContainer={(trigger) => trigger.parentNode.parentNode}
              >
                {typeOptions.map(
                  (type) =>
                    !(
                      parameters[index]?.type == "Grade" && type == "Quality"
                    ) && <Option value={type}>{type}</Option>
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name={`visibility${index + 1}`}
              style={{ marginBottom: "0px" }}
            >
              <p style={{ padding: "4px" }}>Visbility</p>
              <Select
                placeholder="Select"
                suffixIcon={<DownArrowDraw />}
                onChange={handleParameterVisibilityChange}
                value={parameters[index].visibility}
                getPopupContainer={(trigger) => trigger.parentNode.parentNode}
              >
                <Option value="On">On</Option>
                <Option value="Off">Off</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {!(["Length Unit","Weight Unit"].includes(parameters[index]?.type))?<Row>
          <Col span={24}>
            <Form.Item
              name={`defaultValue${index + 1}`}
              rules={
                parameters[index]?.type
                  ? parametersConfig[parameters[index].type]?.rules
                  : []
              }
              style={{ marginBottom: "0px" }}
            >
              <p style={{ padding: "4px" }}>Default Value</p>
              {parameters[index].type &&
                parametersConfig[parameters[index].type]?.type == "dropdown" ? (
                <Select
                  placeholder="Select Value"
                  value={parameters[index].defaultValue || null}
                  onChange={handleParameterValueChange}
                  suffixIcon={<DownArrowDraw />}
                  getPopupContainer={(trigger) => trigger.parentNode.parentNode}
                >
                  {parametersConfig[parameters[index].type]?.data.map(
                    (item) => (
                      <Option value={item}>{item}</Option>
                    )
                  )}
                </Select>
              ) : (
                <Input
                  placeholder="Enter Value"
                  onChange={handleParameterValueChange}
                  value={parameters[index].defaultValue}
                  disabled={!parameters[index].type}
                />
              )}
            </Form.Item>
          </Col>
        </Row>:<></>}
      </div>

      <Divider />
    </div>
  );
};

const OrderCreationConfigSettingDrawer = ({
  visible,
  setVisibleOrderCreationConfigDrawer,
  orderType,
  setActionToaster,
  setDataUpdated,
}) => {
  const [render, setRender] = useState(false);
  const [advancedSettingsData, setAdvancedSettingsData] = useState({});
  const [gradeList, setGradeList] = useState([]);
  const [qualityList, setQualityList] = useState([]);
  const [plyOptions, setPlyOptions] = useState([1, 2, 3, 4]);
  const [deletedParameter, setDeletedParameter] = useState(undefined);
  const parametersConfig = {
    Grade: {
      type: "dropdown",
      data: gradeList,
      rules: [
        {
          required: true,
          message: "This field is required",
        },
      ],
    },
    Quality: {
      type: "dropdown",
      data: qualityList,
      rules: [
        {
          required: true,
          message: "This field is required",
        },
      ],
    },
    Type: {
      type: "dropdown",
      data: ["Reel", "Sheet"],
      rules: [
        {
          required: true,
          message: "This field is required",
        },
      ],
    },
    Ply: {
      type: "dropdown",
      data: plyOptions,
      rules: [
        {
          required: true,
          message: "This field is required",
        },
      ],
    },
    GSM: {
      type: "input",
      rules: [
        {
          required: true,
          message: "This field is required",
        },
        {
          pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
          message: "Positive value upto 3 decimal point is accepted",
        },
      ],
    },
    BF: {
      type: "input",
      rules: [
        {
          required: true,
          message: "This field is required",
        },
        {
          pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
          message: "Positive value upto 3 decimal point is accepted",
        },
      ],
    },
    Bulk: {
      type: "input",
      rules: [
        {
          required: true,
          message: "This field is required",
        },
        {
          pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
          message: "Positive value upto 3 decimal point is accepted",
        },
      ],
    },
    Moisture: {
      type: "input",
      rules: [
        {
          required: true,
          message: "This field is required",
        },
        {
          pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
          message: "Positive value upto 3 decimal point is accepted",
        },
      ],
    },
  };
  const defaultParameter = {
    type: "",
    visibility: "On",
    defaultValue: "",
  };
  const [parameters, setParameters] = useState([]);
  const [typeOptions, setTypeOptions] = useState(orderType=="upload_orders"?[
    "Type",
    "Grade",
    "Ply",
    "GSM",
    "BF",
    "Bulk",
    "Moisture",
    "Length Unit",
    "Weight Unit"
  ]:[
    "Type",
    "Grade",
    "Ply",
    "GSM",
    "BF",
    "Bulk",
    "Moisture",
  ]);
  const mapFrontNameForBackName = {
    "type": "Type",
    "burst_factor": "BF",
    "grade": "Grade",
    "quality": "Quality",
    "ply": "Ply",
    "gsm": "GSM",
    "burst_factor": "BF",
    "bulk": "Bulk",
    "moisture": "Moisture",
    "length_unit":"Length Unit",
    "weight_unit": "Weight Unit"
  }
  const [form] = useForm();

  const getBackendName = (type) => {
    let backendName = "";
    Object.entries(mapFrontNameForBackName).forEach((item) => {
      if (item[1] == type)
        backendName = item[0];
    })
    return backendName;
  }

  const addParameter = () => {
    setParameters([...parameters, defaultParameter]);
  };

  const getGradeList = async () => {
    try {
      const response = await getAllGradesForConfig();
      setGradeList(response.map((item) => item.name));
    } catch (e) {
      console.log(e);
    }
  };

  const getQualityList = async (grade = "") => {
    try {
      const response = await getGradeQualitiesForConfig(grade);
      setQualityList(response.map((item) => item.name));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => { setRender(false) }, [render])

  useEffect(async () => {
    try {
      const settingsData = await getJobCardSerialNumberParam();
      setAdvancedSettingsData(settingsData?.data?.order_creation_config);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    const configData = advancedSettingsData[orderType]?.config;
    if (configData) {
      const parametersArray = [];
      Object.keys(configData).forEach((item, index) => {
        form.setFieldsValue({
          [`type${index + 1}`]: mapFrontNameForBackName[item],
          [`defaultValue${index + 1}`]:
            typeof (configData[item]?.value) == "string"
              ? configData[item]?.value?.charAt(0)?.toUpperCase() +
              configData[item]?.value?.slice(1)
              : configData[item]?.value,
        });
        parametersArray.push({
          type: mapFrontNameForBackName[item],
          visibility: configData[item]?.visibility ? "On" : "Off",
          defaultValue:
            typeof (configData[item]?.value) == "String"
              ? configData[item]?.value?.charAt(0)?.toUpperCase() +
              configData[item]?.value?.slice(1)
              : configData[item]?.value,
        });
      });
      setParameters([...parametersArray]);
      setTypeOptions(
        typeOptions.filter(
          (type) => !Object.keys(configData).includes(getBackendName(type))
        )
      );
      if (Object.keys(configData).includes(getBackendName("Grade"))) {
        setTypeOptions(prev => [...prev, "Quality"]);
        getGradeList();
        getQualityList(configData[getBackendName("Grade")].value);
      }
    }
  }, [advancedSettingsData]);

  useEffect(async () => {
    try {
      if (deletedParameter) {
        let configData = {};
        console.log(parameters)
        parameters.forEach((parameter) => {
          if (parameter.type && parameter?.defaultValue) {
            if(["Length Unit","Weight Unit"].includes(parameter?.type))
            {
              configData[getBackendName(parameter.type)] = {
                value: "default_unit",
                status: 'active',
                visibility: parameter?.visibility == "On",
              };
                
            }else{
              configData[getBackendName(parameter?.type)] = {
                value: parametersConfig[parameter.type].type == "input" ? parseFloat(parameter.defaultValue) : parameter.defaultValue,
                status: 'active',
                visibility: parameter?.visibility == "On",
              };
            }
          }
        });
        const body = {
          ...advancedSettingsData,
          [orderType]: {
            ...advancedSettingsData[orderType],
            config: { ...configData },
          },
        };
        await updateOrderCreationConfig(body);
        setActionToaster({
          error: false,
          msg: "Order Creation Config updated",
        });
        for (let i = 0; i <= parameters.length; i++) {
          form.setFieldsValue({ [`type${i + 1}`]: parameters[i]?.type })
          !["Length Unit","Weight Unit"].includes(parameters[i]?.type) && form.setFieldsValue({ [`defaultValue${i + 1}`]: parameters[i]?.defaultValue })
          form.setFieldsValue({ [`visibility${i + 1}`]: parameters[i]?.visibility })
        }
        setRender(true);
        setDataUpdated(true);
      }
    } catch (e) {
      console.log(e);
    }
  }, [deletedParameter])

  const handleFormSubmit = async () => {
    try {
      let configData = {};
      parameters.forEach((parameter) => {
        if (parameter.type && parameter?.defaultValue) {
          if(["Length Unit","Weight Unit"].includes(parameter.type))
          {
            configData[getBackendName(parameter.type)] = {
              value: "default_unit",
              status: 'active',
              visibility: parameter?.visibility == "On",
            };
          }else{
            configData[getBackendName(parameter.type)] = {
              value: parametersConfig[parameter.type].type == "input" ? parseFloat(parameter.defaultValue) : parameter.defaultValue,
              status: 'active',
              visibility: parameter?.visibility == "On",
            };
          }
        }
      });
      const body = {
        ...advancedSettingsData,
        [orderType]: {
          ...advancedSettingsData[orderType],
          config: { ...configData },
        },
      };
      const response = await updateOrderCreationConfig(body);
      setActionToaster({
        error: false,
        msg: "Order Creation Config updated",
      });
    } catch (e) {
      console.log(e);
    } finally {
      setVisibleOrderCreationConfigDrawer(false);
      setDataUpdated(true);
    }
  };
  return (
    <RightDrawerSidebar
      visible={visible}
      title="Default Values"
      onClose={() => {
        setVisibleOrderCreationConfigDrawer(false);
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields>
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                form={form}
                onFinish={handleFormSubmit}
                onFinishFailed={(item)=>console.log(item)}
              >
                {parameters.map((parameter, index) => (
                  <ParameterFormItem
                    key={index + 1}
                    form={form}
                    index={index}
                    parameters={parameters}
                    setParameters={setParameters}
                    parametersConfig={parametersConfig}
                    typeOptions={typeOptions}
                    setTypeOptions={setTypeOptions}
                    getGradeList={getGradeList}
                    getQualityList={getQualityList}
                    setDeletedParameter={setDeletedParameter}
                    setPlyOptions={setPlyOptions}
                  />
                ))}
                {parameters.length <= 7 && (
                  <div
                    style={{
                      textAlign: "left",
                      height: "100px",
                    }}
                  >
                    <Button
                      className="textTypeBtn textBtnIcon"
                      style={{
                        marginLeft: "0",
                        background: "none",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                      onClick={addParameter}
                    >
                      <Iconmoon icon="addcircle" size={14} color="#EA655B" />
                      Add a Parameter
                    </Button>
                  </div>
                )}
                <div className="buttonFlex fixedBtm">
                  <Button
                    htmlType="submit"
                    className="themeBtn"
                    style={{ width: "100%" }}
                  // onClick={() => setAdd(false)}
                  >
                    <Iconmoon icon="addcircle" size={16} color="#ffffff" /> Save
                    Parameters
                  </Button>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
};

export default OrderCreationConfigSettingDrawer;
